import React from 'react';
import { Box, Group, Loader, Text } from '@mantine/core';
import classes from './ImageGenerationLoadingCard.module.css';

interface ImageGenerationLoadingCardProps {
  label?: string;
}

export const ImageGenerationLoadingCard: React.FC<ImageGenerationLoadingCardProps> = ({
  label = 'Generating image…',
}) => {
  return (
    <Box className={classes.frame} role="status" aria-label={label} data-testid="image-generation-loading-card">
      <Box className={classes.shimmer} aria-hidden="true" />
      <Group gap="xs" className={classes.statusPill}>
        <Loader size={14} color="white" />
        <Text size="sm" className={classes.statusText}>
          {label}
        </Text>
      </Group>
    </Box>
  );
};

export default ImageGenerationLoadingCard;
